document.addEventListener('DOMContentLoaded', () => {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const addAnimation = (slideEl, action) => {
    if (!slideEl) return;
    slideEl.querySelectorAll('[data-animation]').forEach(el => {
      if (prefersReduced) { el.style.opacity = 1; return; }

      const cls = (el.getAttribute('data-animation') || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);

      if (action === 'remove') {
        el.classList.remove('animate__animated', ...cls);
        el.style.opacity = 0;
      } else {
        // restart animation cleanly
        el.classList.remove('animate__animated', ...cls);
        void el.offsetWidth; // reflow
        el.style.opacity = 1;
        el.classList.add('animate__animated', ...cls);
      }
    });
  };

  const swiper = new Swiper('.swiper', {
    loop: true,
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: { nextEl: '.swiper-btn-next', prevEl: '.swiper-btn-prev' },
    on: {
      init() {
        const t = this.slides[this.activeIndex];
        addAnimation(t, 'add');
      },
      slideChange() {
        const t = this.slides[this.activeIndex];
        const s = this.slides[this.previousIndex];
        addAnimation(s, 'remove');
        requestAnimationFrame(() => addAnimation(t, 'add'));
      },
    }
  });

  MATS.animateOnScroll('#cacwelcomecard', 'fadeInUp', { delay: 2 });
  MATS.animateOnScroll('#pcwelcomecard', 'fadeInUp', { delay: 3 });
  MATS.animateOnScroll('#tccwelcomecard', 'fadeInUp', { delay: 4 });

  MATS.animateOnScroll('#projectsectiontitle', 'backInDown', { delay: 0 });
  MATS.animateOnScroll('#projectsectionimage', 'fadeInLeft', { delay: 2 });
  MATS.animateOnScroll('#projectsectioncontext', 'fadeInRight', { delay: 2 });
});
